// src/Start.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./Components/firebase"; // keep your path
import "./Start.css"; // ✅ use the same design css
import Logo from "./assets/logo.png"; // ✅ your logo

const Start = ({
  showForm,
  setShowForm,
  showThankYou,
  setShowThankYou,
  formData,
  setFormData,
  formError,
  setFormError,
  formSubmitted,
  setFormSubmitted,
  onStart,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-show form on first visit
  useEffect(() => {
    const hasSubmitted = localStorage.getItem("formSubmitted");
    if (!hasSubmitted && location.pathname === "/") {
      setShowForm(true);
    } else {
      setFormSubmitted(true);
    }
  }, [location.pathname, setShowForm, setFormSubmitted]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const { name, mobileNumber, email } = formData;

    if (!name || name.trim().length < 2) return "Please enter your name.";
    const m = (mobileNumber || "").replace(/\D/g, "");
    if (m.length !== 10) return "Please enter a valid 10-digit mobile number.";
    if (!email || !email.trim().includes("@")) return "Please enter a valid email.";
    return "";
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormError("");

    const msg = validate();
    if (msg) return setFormError(msg);

    try {
      await addDoc(collection(db, "leads"), {
        name: (formData.name || "").trim(),
        email: (formData.email || "").trim().toLowerCase(),
        mobileNumber: (formData.mobileNumber || "").replace(/\D/g, ""),
        projectName: "Clarks-Exotica",
        timestamp: serverTimestamp(),
      });

      localStorage.setItem("formSubmitted", "true");

      setShowForm(false);
      setShowThankYou(true);

      setTimeout(() => {
        setShowThankYou(false);
        setFormSubmitted(true);
        navigate("/explore");
      }, 2000);
    } catch (err) {
      console.error("Submission error:", err);
      setFormError("Failed to submit. Please try again.");
    }
  };

  const handleExplore = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      onStart?.(); // parent can navigate
    }, 600);
  };

  const handleBooking = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      navigate("/booking");
    }, 600);
  };

  // ✅ Thank You Screen (same design)
  if (showThankYou) {
    return (
      <div className="lead-shell">
        <div className="lead-split-card">
          <div
            className="lead-left"
            style={{ backgroundImage: `url("/villa.jpg")` }} // ✅ public/villa.jpg
          >
            <div className="lead-left-overlay" />
            <div className="lead-left-content">
              <div className="lead-left-top">
                <img className="lead-left-logo" src={Logo} alt="Logo" />
             
              </div>

              <div className="lead-left-headline">
                <p className="lead-left-small">Thank you</p>
                <h1>SUBMITTED</h1>
                <p className="lead-left-desc">
                  Your details have been submitted successfully. Redirecting…
                </p>
              </div>
            </div>
          </div>

          <div className="lead-right">
            <div className="lead-right-inner">
              <h2 className="lead-form-title">Done ✅</h2>
              <p className="lead-form-subtitle">
                You will be redirected to the experience in a moment.
              </p>
            </div>
          </div>
        </div>

        <p className="lead-trust-powereds">
          Powered by <strong>Luminexa Technologies</strong>
        </p>
      </div>
    );
  }

  // ✅ Form Screen (Split design)
  if (showForm && !formSubmitted) {
    return (
      <div className="lead-shell">
        <div className="lead-split-card">
          {/* LEFT */}
          <div
            className="lead-left"
            style={{ backgroundImage: `url("/villa.jpg")` }} // ✅ public/villa.jpg
          >
            <div className="lead-left-overlay" />
            <div className="lead-left-content">
              <div className="lead-left-top">
                <img className="lead-left-logo" src={Logo} alt="Logo" />
                
              </div>

              <div className="lead-left-headline">
                <p className="lead-left-small">Nice to see you</p>
                <h1>WELCOME</h1>
                <p className="lead-left-desc">
                  Clarks Exotica Sakleshpur offers investors a rare opportunity to own a fully managed 4- star resort villa with monthly revenue sharing and zero operational hassle.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="lead-right">
            <div className="lead-right-inner">
              <h2 className="lead-form-title">Continue</h2>
              <p className="lead-form-subtitle">
                Please enter your details to access the experience.
              </p>

              <form onSubmit={handleFormSubmit} className="lead-form">
                <label className="lead-label">Full Name</label>
                <input
                  className="lead-input"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name || ""}
                  onChange={handleInputChange}
                  autoComplete="name"
                />

                <label className="lead-label">Mobile Number</label>
                <input
                  className="lead-input"
                  placeholder="Enter mobile number"
                  name="mobileNumber"
                  value={formData.mobileNumber || ""}
                  onChange={handleInputChange}
                  inputMode="numeric"
                  autoComplete="tel"
                />

                <label className="lead-label">Email Address</label>
                <input
                  className="lead-input"
                  placeholder="Enter email address"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleInputChange}
                  autoComplete="email"
                />

                {formError && <div className="lead-error">{formError}</div>}

                <button className="lead-btn" type="submit">
                  SUBMIT & CONTINUE
                </button>

                <div className="lead-trust">
                  <p className="lead-trust-text">
                    By submitting, you agree to be contacted by{" "} <br/>
                    <b>MLA Estates</b>.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>

        <p className="lead-trust-powereds">
          Powered by <strong>Luminexa Technologies</strong>
        </p>
      </div>
    );
  }

  // ✅ After submitted: show landing buttons (same split card design)
  return (
    <>
      <div className={`lead-shell ${isTransitioning ? "fade-out" : ""}`}>
        <div className="lead-split-card">
          {/* LEFT */}
          <div
            className="lead-left"
            style={{ backgroundImage: `url("/villa.jpg")` }}
          >
            <div className="lead-left-overlay" />
            <div className="lead-left-content">
              <div className="lead-left-top">
                <img className="lead-left-logo" src={Logo} alt="Logo" />
                
              </div>

              <div className="lead-left-headline">
                <p className="lead-left-small">Choose your perfect Villa</p>
                <h1>EXPLORE NOW</h1>
                <p className="lead-left-desc">
                  Clarks Exotica Sakleshpur offers investors a rare opportunity to own a fully managed 4- star resort villa with monthly revenue sharing and zero operational hassle.
               
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT */}
         {/* RIGHT */}
<div className="lead-right">
  <div className="lead-right-inner">
    {/* Status */}
    

    <h2 className="lead-form-title">Welcome to Clarks Exotica</h2>
    <p className="lead-form-subtitle">
      Your access is verified. Choose what you’d like to do next.
    </p>

    {/* CTA cards */}
    <div className="lead-cta-grid">
      <button className="lead-cta-card" onClick={handleExplore} type="button">
        <div className="lead-cta-icon">🧭</div>
        <div className="lead-cta-text">
          <div className="lead-cta-title">Immersive Tour</div>
<div className="lead-cta-sub">
  Explore the project in 360° view
</div>

        </div>
        <div className="lead-cta-arrow">→</div>
      </button>

      <button className="lead-cta-card" onClick={handleBooking} type="button">
        <div className="lead-cta-icon">🏘️</div>
        <div className="lead-cta-text">
          <div className="lead-cta-title">Book Villa</div>
<div className="lead-cta-sub">
  Check availability & reserve your villa
</div>

        </div>
        <div className="lead-cta-arrow">→</div>
      </button>
    </div>

    {/* Info row */}
    <div className="lead-mini-cards">
      <div className="lead-mini-card">
        <div className="lead-mini-title">Location</div>
        <div className="lead-mini-sub">Clarks Exotica - Sakleshpura</div>
      </div>
      <div className="lead-mini-card">
        <div className="lead-mini-title">Support</div>
        <div className="lead-mini-sub">crm@landandkeys.in +91 70027 27965</div>
      </div>
    </div>

    <div className="lead-trust">
      <p className="lead-trust-text">
        MLA Estates • Bengaluru 560041
      </p>
    </div>
  </div>
</div>

        </div>

        <p className="lead-trust-powereds">
          Powered by <strong>Luminexa Technologies</strong>
        </p>
      </div>

      {/* Optional fade overlay (if you already use this in CSS) */}
      {isTransitioning && <div className="page-transition-overlay" />}
    </>
  );
};

export default Start;
